export const Colors = {
  // Base Palette Definitions (Raw Colors)
  white: "#FFFEFE",
  alabasterGrey: "#DCDDDE",
  granite: "#465C4C", // Note: This is actually dark green, kept for backward compatibility
  porcelain: "#F4F5F1",
  white2: "#FCFDFD",
  white3: "#FFFFFF",
  contestGold: "#8B6F47", // Golden-brown for contest separators and category labels
  contestLightGreen: "#C8E6C9", // Light green for contest award buttons
  sttGreen: "#c5ddc7",

  // Functional colors (Defaults, can be updated to match new palette if needed)
  success: "#28a745",
  error: "#dc3545",
  warning: "#ffc107",
  info: "#17a2b8",

  // Theme-specific colors
  light: {
    // Mapping raw colors to semantic names
    background: "#FFFFFF", // white3 - main background
    surface: "#FFFFFF", // white - cards/containers
    text: "#465C4C",
    textSecondary: "#A0A2A3", // alabasterGrey - lighter text
    textTertiary: "#000", // black - tertiary text
    textInverse: "#FFFFFF", // white - for use on dark backgrounds
    border: "#DCDDDE", // alabasterGrey - borders

    // Keeping semantic overrides if needed
    primary: "#465C4C", // Dark green
    secondary: "#DCDDDE", // alabasterGrey
    tertiary: "#F4F5F1", // porcelain
    contestGold: "#8B6F47", // Golden-brown
    contestLightGreen: "#C8E6C9", // Light green
    shadow: "rgba(0, 0, 0, 0.12)",
  },
  dark: {
    // dark theme to match previous Home.js styling
    background: "#0f1817", // Deep dark green/black from original home page
    surface: "#263a38", // Lighter dark green for cards (taken from nav/inputs)
    text: "#ffffff", // White text for dark mode
    textSecondary: "#b0b0b0",
    textTertiary: "#ffffff", // white - tertiary text
    textInverse: "#000000", // black - for use on light backgrounds
    border: "#5a6f6d", // Muted green border
    primary: "#ffffff", // White primary in dark mode
    secondary: "#263a38",
    tertiary: "#263a38",
    contestGold: "#B8860B", // Lighter golden-brown for better visibility in dark mode
    contestLightGreen: "#81C784", // Medium green for better visibility in dark mode
    shadow: "rgba(0, 0, 0, 0.45)",
  },
};

// Helper to get colors based on theme
export const getThemeColors = (theme) => {
  return Colors[theme] || Colors.light;
};
